import FileServiceModel   from '@/models/FileServiceModel';
import doc                from '@widesk-core/decorators/doc';
import model              from '@widesk-core/decorators/model';

@model.urnResource('type')
@doc.path('/stonecode_file_types/{?id}')
export default class TypeModel extends FileServiceModel {
	public declare _tsFilters: {
		'deprecated': '0' | '1';
		'policy': id;
		'policy.reference': FilePolicyReference;
		'reference': FileTypeReference;
		'service': id;
		'service.serviceUrn': string;
		'system': '0' | '1';
		'urnMask': string;
	};

	public declare _tsSorts: {
		'id': string;
		'label': string;
		'updatedAt': string;
	};

	@doc.boolean declare defaultLock: boolean;
	@doc.boolean declare deprecated: boolean;
	@doc.string declare label: string;
	@doc.number declare maxPerSource: number;
	@doc.number declare maxSize: number;
	@doc.string declare reference: FileTypeReference;
	@doc.boolean declare system: boolean;
	@doc.string declare urnMask: string;
}
